{
  "name": "microbuild-management-mobile",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "node start-server.js",
    "build": "ng build",
    "build.dev": "ng build --configuration development",
    "serve.pwa": "ng build --source-map && node -e \"require('fs').writeFileSync('dist/MicrobuildManagementMobile/browser/env.js', 'window.__env = { pwa: true };')\" && npx http-server dist/MicrobuildManagementMobile/browser -p 8100 -a localhost -c-1 -o --proxy \"http://localhost:8100?\"",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "packageManager": "npm@10.9.0",
  "dependencies": {
    "@angular/common": "^22.0.1",
    "@angular/compiler": "^22.0.1",
    "@angular/core": "^22.0.1",
    "@angular/forms": "^22.0.1",
    "@angular/platform-browser": "^22.0.1",
    "@angular/router": "^22.0.1",
    "@angular/service-worker": "^22.0.5",
    "@capacitor/barcode-scanner": "^3.0.2",
    "@capacitor/camera": "^8.2.0",
    "@capacitor/core": "^8.4.1",
    "@ionic/angular": "^8.8.8",
    "@ionic/pwa-elements": "^3.4.0",
    "@ionic/storage-angular": "^4.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "fabric": "^7.4.0",
    "oidc-client-ts": "^3.5.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^22.0.1",
    "@angular/cli": "^22.0.1",
    "@angular/compiler-cli": "^22.0.1",
    "@ionic/angular-toolkit": "^12.3.0",
    "jsdom": "^28.0.0",
    "prettier": "^3.8.1",
    "typescript": "~6.0.3",
    "vitest": "^4.0.8"
  }
}
